import type { InsightKey } from "@tandemdiabetes/sugarmate-api-react-client"
import { Toast } from "@tandemdiabetes/sugarmate-react-components"
import { usePolyglot } from "src/contexts"

interface Props {
  id: string;
  insightKey: InsightKey;
}

export function RemoveInsightErrorToast(props: Props) {
  const {
    id, insightKey,
  } = props

  const polyglot = usePolyglot()

  return (
    <Toast
      stylePreset="error"
      body={polyglot.t(
        "toasts.remove_insight_error.body",
        { name: polyglot.t(`insights.title.${insightKey}`) },
      )}
      id={id}
    />
  )
}
